"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntervalButtons = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _tickersActions = require("../../redux/actions/tickersActions");
var _futuresTickersActions = require("../../redux/futures/actions/futuresTickersActions");
var _tickerHelper = require("../../helpers/tickerHelper");
var _config = _interopRequireDefault(require("../../config"));
require("./IntervalButtons.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var IntervalButtons = exports.IntervalButtons = function IntervalButtons(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "interval-buttons-wrapper"
  }, _config["default"].LightWeightCharts.supportedIntervals.map(function (i) {
    return /*#__PURE__*/_react["default"].createElement(ConnectedIntervalButton, {
      key: i,
      interval: i,
      isFuturesActive: props.isFuturesActive,
      value: _tickerHelper.SUPPORTED_TICKER_INTERVALS[i]
    });
  }));
};
var IntervalButton = function IntervalButton(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: "ap-inline-btn__btn lightweight-interval-button ".concat(props.selectedInterval === props.value ? 'active' : ''),
    label: props.interval,
    onClick: props.changeTickersInterval,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("span", null, t(props.interval)));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedInterval: state.tickers.interval
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    changeTickersInterval: function changeTickersInterval() {
      if (ownProps.isFuturesActive) {
        dispatch((0, _futuresTickersActions.changeFuturesTickersInterval)((0, _tickerHelper.convertLabelToTickerInterval)(ownProps.interval)));
      }
      dispatch((0, _tickersActions.changeTickersInterval)((0, _tickerHelper.convertLabelToTickerInterval)(ownProps.interval)));
    }
  };
};
var ConnectedIntervalButton = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IntervalButton);